import { Divider, Icon } from 'antd';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

export class ActionContent extends PureComponent {
  render() {
    const {
      onEditItem, onViewItem, onDeleteItem, quyen
    } = this.props;
    if (quyen) {
      return (
        <>
          {quyen.sua && onEditItem
            && (
              <span
                className="qti-mouseover"
                onClick={onEditItem}
                title="Sửa"
              ><Icon type="edit" />
              </span>
            )}
          {quyen.xoa && onDeleteItem && quyen.sua && onEditItem
            && <Divider type="vertical" />}
          {quyen.xoa && onDeleteItem
            && (
              <span
                className="qti-mouseover"
                onClick={onDeleteItem}
                title="Xóa"
              ><Icon type="delete" />
              </span>
            )}
          {quyen.xem && onViewItem && ((quyen.sua && onEditItem) || (quyen.xoa && onDeleteItem))
            && <Divider type="vertical" />}
          {quyen.xem && onViewItem
            && (
              <span
                className="qti-mouseover"
                onClick={onViewItem}
                title="Chi tiết"
              ><Icon type="info-circle" />
              </span>
            )}
        </>
      );
    }
    return null;
  }
}

ActionContent.propTypes = {
  onEditItem: PropTypes.func,
  onViewItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  quyen: PropTypes.object
};

ActionContent.defaultProps = {
  onViewItem: undefined,
  onEditItem: undefined,
  quyen: undefined,
  onDeleteItem: undefined
};

export default ActionContent;
